var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationPayrollReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "inherit",
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.572 11.495h-.5v1h.5v-1Zm6.857 1h.5v-1h-.5v1ZM8.572 14.92h-.5v1h.5v-1Zm6.856 1.008h.5l.001-1h-.5v1Zm-6.856-7.86h-.5v1h.5v-1Zm4.57 1.002h.5l.001-1h-.5v1ZM15.43 4l.353-.354-.146-.146h-.207V4Zm3.428 3.429h.5V7.22l-.146-.146-.354.354ZM8.572 12.495h6.857v-1H8.572v1Zm0 3.426 6.856.008.001-1-6.857-.008v1Zm0-6.853 4.57.003.001-1-4.571-.003v1ZM17.714 19.5H6.285v1h11.43v-1Zm-12.072-.643V5.143h-1v13.714h1ZM6.286 4.5h9.143v-1H6.286v1Zm12.071 2.929v11.428h1V7.43h-1Zm-3.282-3.075 3.429 3.428.707-.707-3.429-3.429-.707.708ZM6.285 19.5a.643.643 0 0 1-.642-.643h-1c0 .908.736 1.643 1.643 1.643v-1Zm11.43 1c.907 0 1.642-.735 1.642-1.643h-1a.643.643 0 0 1-.642.643v1ZM5.643 5.143c0-.355.288-.643.643-.643v-1c-.907 0-1.643.736-1.643 1.643h1Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationPayrollReports);
export default __webpack_public_path__ + "static/media/navigation-payroll-reports.65df40828294a53f25c164d406dcdea4.svg";
export { ForwardRef as ReactComponent };